import { render, staticRenderFns } from "./RememberPasswordBox.vue?vue&type=template&id=0975e32a&scoped=true"
import script from "./RememberPasswordBox.vue?vue&type=script&lang=js"
export * from "./RememberPasswordBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975e32a",
  null
  
)

export default component.exports